import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./traineePortal.css";

const TraineeSkill = () => {
  const [skills, setSkills] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState("");
  const [proficiencyLevel, setProficiencyLevel] = useState("");
  const { profileId } = useParams();
  const navigate = useNavigate();

  const traineeId = localStorage.getItem("traineeId");

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const response = await AxiosInstance.get("companies/skills/");
        setSkills(response.data);
      } catch (error) {
        console.error("Error fetching skills:", error);
      }
    };
    fetchSkills();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newTraineeSkill = {
      trainee: traineeId,
      skill: selectedSkill,
      proficiency_level: proficiencyLevel,
    };

    try {
      const response = await AxiosInstance.post("companies/skill", newTraineeSkill);
      if (response.status === 201 || response.status === 200) {
        console.log("Trainee skill added:", response.data);
        navigate("/trainee-career-preference");
      } else {
        console.error("Failed to create trainee skill:", response);
      }
    } catch (error) {
      console.error("Error creating trainee skill:", error);
    }
  };

  const closeModal = () => {
    navigate("/trainee-career-preference");
  };

  return (
    <div className="als-trainee-form-page">
      <div className="als-trainee-form-card">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">Add Skill</h2>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="skill" className="form-label">Skill</label>
              <select
                id="skill"
                className="form-select"
                value={selectedSkill}
                onChange={(e) => setSelectedSkill(e.target.value)}
                required
              >
                <option value="">Select Skill</option>
                {skills.map((skill) => (
                  <option key={skill.skill_id} value={skill.skill_id}>
                    {skill.skill_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-4">
              <label htmlFor="proficiencyLevel" className="form-label">Proficiency Level</label>
              <select
                id="proficiencyLevel"
                className="form-select"
                value={proficiencyLevel}
                onChange={(e) => setProficiencyLevel(e.target.value)}
                required
              >
                <option value="">Select Proficiency Level</option>
                <option value="Beginner">Beginner</option>
                <option value="Intermediate">Intermediate</option>
                <option value="Advanced">Advanced</option>
                <option value="Expert">Expert</option>
              </select>
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-primary">Save Skill</button>
            </div>
          </form>
      </div>
    </div>
  );
};

export default TraineeSkill;
